import { Box, Button, Collapse, Text, useDisclosure } from "@chakra-ui/react";
import { AxiosError } from "axios";
import { formatErrorResponse } from "../../shared/utils/format-response-error";
import { regenerateFailureText } from "./reviewRules";

/** A failed PDF regeneration as the reviewer reads it (see `regenerateFailureText`). */
export function describeRegenerateError(error: unknown) {
  const isAxiosError = error instanceof AxiosError;
  return regenerateFailureText({
    isNetworkError: isAxiosError && error.response === undefined,
    serverMessage: formatErrorResponse(error),
    status: isAxiosError ? error.response?.status ?? null : null,
  });
}

/** The friendly reason, then the raw server message behind "Details" when there is one. */
export default function RegenerateFailureDetails(props: { error: unknown }) {
  const { details, summary } = describeRegenerateError(props.error);
  const disclosure = useDisclosure();

  return (
    <Box>
      <Text>{summary}</Text>
      {details !== null && (
        <>
          <Button
            color="inherit"
            fontWeight="medium"
            size="xs"
            textDecoration="underline"
            variant="link"
            onClick={disclosure.onToggle}
          >
            {disclosure.isOpen ? "Hide details" : "Details"}
          </Button>
          <Collapse animateOpacity in={disclosure.isOpen}>
            <Text
              fontFamily="mono"
              fontSize="xs"
              mt={1}
              whiteSpace="pre-wrap"
              wordBreak="break-word"
            >
              {details}
            </Text>
          </Collapse>
        </>
      )}
    </Box>
  );
}
